import { Box, TextField } from "@mui/material";
import CustomTypography from "../../../../../Components/Typography";
import { useState, useEffect } from "react";
import SingleServiceAccordion from "../../../../../Components/SingleServiceAccordian";
import { visitPriceFieldStyle } from "../styles";
import CustomTooltip from "../../../../../Components/CustomTooltip";
import { getCurrencySymbol } from "../../../../../Utils/CountriesData/getCountriesData";
import { apiGetRequest } from "../../../../../Helpers/Requests";
import endpoints from "../../../../../Helpers/Endpoints";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../../../../Helpers/formating";
import {
  addPricesTextStyle,
  subcategoryNameTextStyle,
  subpricelistNameTextStyle,
} from "../../../styles/styles";
import { sortPricelistHierarchy } from "../../../../../Utils/SortData";
import emitter from "../../../../../Utils/events/eventBus";
import OrderMinimumHint from "../../../../../Components/OrderMinimumHint";

const PriceServicesStep = (props) => {
  const { valuesRef, onVariantPriceChange } = props;
  const { t, i18n } = useTranslation([
    "price-services-steps",
    "categories",
    "sku",
    "units",
  ]);
  const isHebrew = i18n.language === "he";

  const {
    pricelist: { subcategory_name, sub_pricelists = [], currency },
  } = valuesRef.current;

  const sortedSubPricelists = sortPricelistHierarchy(sub_pricelists);

  const currencySymbol = getCurrencySymbol(currency);
  const [expandedAccordion, setExpandedAccordion] = useState(null);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };

  const updatePriceComparison = async (variantId, price) => {
    const updatedPrice = price === null ? 0 : price;

    try {
      const url = `${endpoints.compareVariantPrice}?variant_id=${variantId}&price=${updatedPrice}`;
      const response = await apiGetRequest(url);

      const comparison = response.data?.data?.comparison;

      const refreshedSubPricelists =
        valuesRef.current.pricelist.sub_pricelists.map((sub) => {
          const updatedServices = sub.services.map((service) => {
            const updatedVariants = service.variants.map((variant) => {
              if (variant.id === variantId) {
                return {
                  ...variant,
                  price_comparison: comparison,
                };
              }
              return variant;
            });

            return {
              ...service,
              variants: updatedVariants,
            };
          });

          return { ...sub, services: updatedServices };
        });

      if (valuesRef) {
        valuesRef.current.pricelist.sub_pricelists = refreshedSubPricelists;
      }
    } catch (error) {
      console.error("Price comparison error:", error);
    }
  };

  const handlePriceChange = (variantId, unit, value, serviceId) => {
    console.log("check blur", variantId);
    const numericPrice = value === null ? null : parseFloat(value);
    const updatedSubPricelists = valuesRef.current.pricelist.sub_pricelists.map(
      (sub) => {
        const updatedServices = sub.services.map((service) => {
          const updatedVariants = service.variants.map((variant) => {
            if (variant.id === variantId && variant.unit === unit) {
              return {
                ...variant,
                price: numericPrice,
              };
            }
            return variant;
          });

          const pricedCount = updatedVariants.filter(
            (variant) => typeof variant.price === "number" && variant.price > 0
          ).length;

          return {
            ...service,
            variants: updatedVariants,
            priced_variants: pricedCount,
          };
        });

        return { ...sub, services: updatedServices };
      }
    );

    if (valuesRef) {
      valuesRef.current.pricelist.sub_pricelists = updatedSubPricelists;
    }

    onVariantPriceChange?.(updatedSubPricelists);

    const updatedServiceSub = updatedSubPricelists.find((sub) =>
      sub.services.some((s) => s.id === serviceId)
    );

    const service = updatedServiceSub?.services.find((s) => s.id === serviceId);

    if (service) {
      emitter.emit(
        `service-priced-variants-updated-${serviceId}`,
        service.priced_variants
      );
    }
    updatePriceComparison(variantId, numericPrice);
  };

  const preventScroll = (e) => e.preventDefault();

  const priceServicesTableConfig = {
    columns: [
      {
        id: "variant",
        label: t("table_columns.variant_sku"),
        colSpan: 2,
        render: (variant) => t(variant.sku, { ns: "sku" }),
        headerStyle: {
          width: "40%",
          transform: "translateZ(0)",
          backfaceVisibility: "hidden",
          willChange: "transform",
          borderRight: "1px solid #EAEAEA",
        },
        cellStyle: {
          transform: "translateZ(0)",
          backfaceVisibility: "hidden",
          willChange: "transform",
          borderRight: "1px solid #EAEAEA",
        },
      },
      {
        id: "unit",
        label: t("table_columns.unit"),
        render: (variant) => t(variant.unit, { ns: "units" }),
        headerStyle: { width: "20%", borderLeft: "none !important" },
        cellStyle: {
          borderLeft: "none !important",
        },
      },
      {
        id: "price",
        label: t("table_columns.starting_price"),
        render: (variant, serviceId) => {
          const { price, price_comparison } = variant;

          const hasPriceValue =
            price !== null && price !== undefined && price !== "";
          const isLowerPrice = price_comparison === "lower";
          const isHigherPrice = price_comparison === "higher";
          const tooltipText = isLowerPrice
            ? t("table_columns.price_lower_80_percent")
            : isHigherPrice
            ? t("table_columns.price_higher_80_percent")
            : "";

          return (
            <Box
              display="flex"
              gap="8px"
              alignItems="center"
              justifyContent="space-between"
            >
              <PriceInput
                price={price}
                variantId={variant.id}
                variantUnit={variant.unit}
                handlePriceChange={handlePriceChange}
                onInputChange={onVariantPriceChange}
                valuesRef={valuesRef}
                currencySymbol={currencySymbol}
                isHebrew={isHebrew}
                visitPriceFieldStyle={visitPriceFieldStyle}
                preventScroll={preventScroll}
                serviceId={serviceId}
              />
              {hasPriceValue && (isLowerPrice || isHigherPrice) && (
                <CustomTooltip title={tooltipText}>
                  {isHigherPrice && (
                    <img src="/alert_red_icon.svg" alt="alert icon" />
                  )}
                  {isLowerPrice && (
                    <img src="/alert_green_icon.svg" alt="alert icon" />
                  )}
                </CustomTooltip>
              )}
            </Box>
          );
        },
        headerStyle: {
          width: "20%",
        },
      },
      {
        id: "market-price",
        label: t("table_columns.typical_market_price"),
        render: (variant) => {
          const { market_price_range } = variant;
          // Percentage-based variants display market prices as percentages.
          const isPct = variant.unit === "Percentage";
          const prefix = isPct ? "" : currencySymbol;
          const suffix = isPct ? "%" : "";
          if (market_price_range) {
            const min = formatPrice(market_price_range.min);
            const max = formatPrice(market_price_range.max);

            if (min != null && max != null) {
              return `${prefix}${min}${suffix} - ${prefix}${max}${suffix}`;
            } else if (min != null) {
              return `${prefix}${min}${suffix}`;
            } else if (max != null) {
              return `${prefix}${max}${suffix}`;
            }
          }
          return "";
        },
        headerStyle: { width: "20%" },
      },
    ],
  };

  const totalServices = sortedSubPricelists.reduce((count, sub) => {
    const validVariantCount =
      sub.services?.reduce((sum, service) => {
        return sum + (service.variants?.length || 0);
      }, 0) || 0;

    return count + validVariantCount;
  }, 0);

  const processedSubPricelists = sortedSubPricelists
    .map((sub) => ({
      ...sub,
      validServices:
        sub.services?.filter((s) => s.variants && s.variants.length > 0) || [],
    }))
    .filter((sub) => sub.validServices.length > 0);

  const hasSingleSubPricelist = processedSubPricelists.length === 1;

  const allValidServices = processedSubPricelists.flatMap(
    (sub) => sub.validServices
  );

  const hasSingleService = allValidServices.length === 1;

  useEffect(() => {
    if (hasSingleService && allValidServices[0]) {
      setExpandedAccordion(allValidServices[0].id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSingleService]);

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "42px" }}>
        <Box>
          <CustomTypography props={subcategoryNameTextStyle}>
            {hasSingleSubPricelist
              ? t(processedSubPricelists[0].sub_pricelist_name, {
                  ns: "categories",
                })
              : t(subcategory_name, { ns: "categories" })}{" "}
            ({totalServices} {t("services")})
          </CustomTypography>
          <CustomTypography props={addPricesTextStyle}>
            {t("add_prices")}
          </CustomTypography>

          <CustomTypography props={addPricesTextStyle}>
            {t("prices_include_vat")}
          </CustomTypography>

          {/* A service may be priced at any amount; the ORDER is what carries
              a minimum, so the supplier meets the rule here rather than on a
              blocked order later. */}
          <OrderMinimumHint />
        </Box>

        {sortedSubPricelists.map((subpricelist) => {
          const { sub_pricelist_name, services } = subpricelist;

          const validServices =
            services?.filter(
              (service) => service.variants && service.variants.length > 0
            ) || [];

          if (validServices.length === 0) return null;
          return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {!hasSingleSubPricelist ? (
                <CustomTypography props={subpricelistNameTextStyle}>
                  {t(sub_pricelist_name, { ns: "categories" })}
                </CustomTypography>
              ) : null}
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                {validServices.map((service) => (
                  <SingleServiceAccordion
                    key={service.id}
                    service={service}
                    isOffered
                    viewType="invite"
                    expandedAccordion={expandedAccordion}
                    handleAccordionChange={handleAccordionChange}
                    tableConfig={priceServicesTableConfig}
                    symbol={currencySymbol}
                    isPriclistPage
                    moveToTop
                    showVAtText
                  />
                ))}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

const PriceInput = ({
  price,
  variantId,
  variantUnit,
  handlePriceChange,
  onInputChange,
  valuesRef,
  currencySymbol,
  isHebrew,
  visitPriceFieldStyle,
  preventScroll,
  serviceId,
}) => {
  const [localPrice, setLocalPrice] = useState(price ?? "");

  // Percentage-based variants are priced as "% of deal" — we show the "%"
  // symbol instead of the currency symbol next to the price input.
  const isPercentageVariant = variantUnit === "Percentage";
  const unitSymbol = isPercentageVariant ? "%" : currencySymbol;

  useEffect(() => {
    setLocalPrice(price ?? "");
  }, [price]);

  const notifyPriceStatus = (currentValue) => {
    if (!onInputChange || !valuesRef) return;
    const hasCurrentInput =
      currentValue !== null && currentValue !== "" && Number(currentValue) > 0;

    // Build a temporary copy with the current input's value applied
    const tempSubPricelists =
      valuesRef.current.pricelist.sub_pricelists.map((sub) => ({
        ...sub,
        services: sub.services?.map((service) => ({
          ...service,
          variants: service.variants?.map((variant) => {
            if (variant.id === variantId && variant.unit === variantUnit) {
              return {
                ...variant,
                price: hasCurrentInput ? Number(currentValue) : null,
              };
            }
            return variant;
          }),
        })),
      }));

    onInputChange(tempSubPricelists);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      setLocalPrice(null);
      notifyPriceStatus(null);
      return;
    }
    const regex = /^\d+(\.\d{0,2})?$/;

    if (regex.test(value)) {
      setLocalPrice(value);
      notifyPriceStatus(value);
    }
  };

  const handleBlur = (e) => {
    e.target.removeEventListener("wheel", preventScroll);
    const rawValue = e.target.value;
    const value = rawValue === "" ? null : Number(rawValue);

    handlePriceChange(variantId, variantUnit, value, serviceId);
  };

  return (
    <Box
      sx={{
        direction: isHebrew && "rtl",
        display: "flex",
        gap: "4px",
        alignItems: "center",
      }}
    >
      <CustomTypography
        props={{
          color: "#2F2B3D",
          fontSize: "13px",
          fontWeight: 500,
          lineHeight: "18px",
        }}
      >
        {unitSymbol}
      </CustomTypography>
      <TextField
        type="number"
        value={localPrice}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === "-" || e.key === "e" || e.key === "E") {
            e.preventDefault();
          }
        }}
        onFocus={(e) => {
          e.target.addEventListener("wheel", preventScroll, {
            passive: false,
          });
        }}
        onBlur={handleBlur}
        variant="outlined"
        sx={visitPriceFieldStyle}
        inputProps={{ min: 0, max: isPercentageVariant ? 100 : undefined }}
      />
    </Box>
  );
};

export default PriceServicesStep;
